// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34hef","top":"styles_top__D-JM3"};